import { SHARE } from '../constants/variables';

const shareColorScope = [ 0.001, 0.01, 0.05, 0.1, 0.5, 1 ];
const shareTandemColorScope = [ 1, 5, 10, 15, 20, 25 ];
const absColorScope = {
    30: [ 5, 100, 250, 500, 750, 1000 ],
    7: [ 2, 10, 50, 100, 250, 500 ],
    1: [ 1, 5, 10, 25, 50, 70 ],
};
const absTandemColorScope = {
    30: [ 5, 10, 25, 50, 75, 150 ],
    7: [ 2, 10, 20, 30, 50, 100 ],
    1: [ 1, 5, 10, 15, 20, 30 ],
};

export const getStartFinishTrackColorScope = (days, mode) => {
    if (mode === SHARE) {
        return shareColorScope;
    } else if (mode === 'TANDEM') {
        return absTandemColorScope[days];
    } else if (mode === 'TANDEM_SHARE') {
        return shareTandemColorScope;
    }
    return absColorScope[days];
};
